// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"24fc6a0c","385":"4074a91f","442":"fd9792cd","530":"ba6d69fd","973":"5b55601b"}[chunkId] + ".chunk.css";
};